var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSortDefault(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.83767 5.60248C7.69517 5.60248 7.55265 5.55 7.44015 5.4375L5.04765 3.045L2.65514 5.4375C2.43764 5.655 2.07765 5.655 1.86015 5.4375C1.64265 5.22 1.64265 4.86 1.86015 4.6425L4.65017 1.85248C4.75517 1.74748 4.89765 1.6875 5.04765 1.6875C5.19765 1.6875 5.34017 1.74748 5.44517 1.85248L8.23515 4.6425C8.45265 4.86 8.45265 5.22 8.23515 5.4375C8.12265 5.55 7.98017 5.60248 7.83767 5.60248Z",
    fill: "#6C757D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.04736 16.3125C4.73986 16.3125 4.48486 16.0575 4.48486 15.75V2.25C4.48486 1.9425 4.73986 1.6875 5.04736 1.6875C5.35486 1.6875 5.60986 1.9425 5.60986 2.25V15.75C5.60986 16.0575 5.35486 16.3125 5.04736 16.3125Z",
    fill: "#6C757D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.96 16.3125C12.81 16.3125 12.6675 16.2526 12.5625 16.1476L9.7725 13.3575C9.555 13.14 9.555 12.78 9.7725 12.5625C9.99 12.345 10.35 12.345 10.5675 12.5625L12.96 14.955L15.3525 12.5625C15.57 12.345 15.93 12.345 16.1475 12.5625C16.365 12.78 16.365 13.14 16.1475 13.3575L13.3575 16.1476C13.2525 16.2526 13.1025 16.3125 12.96 16.3125Z",
    fill: "#6C757D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9526 16.3125C12.6451 16.3125 12.3901 16.0575 12.3901 15.75V2.25C12.3901 1.9425 12.6451 1.6875 12.9526 1.6875C13.2601 1.6875 13.5151 1.9425 13.5151 2.25V15.75C13.5151 16.0575 13.2676 16.3125 12.9526 16.3125Z",
    fill: "#6C757D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortDefault);
export default __webpack_public_path__ + "static/media/sort-default.df5f61b64c7773122c861cb3f76e291e.svg";
export { ForwardRef as ReactComponent };